import { Konva } from './_FullInternals.js';
export default Konva;



//////////////////
// WEBPACK FOOTER
// ./~/konva/lib/index.js
// module id = 515
// module chunks = 24